module.exports = __webpack_public_path__ + "media/images/countryrect/mp-c40418d5e0fa06bde6db9931222ab80e.svg";